export const frequencyTypes = [
	{ id: 'once', value: 'Única vez', disabled: false },
	{ id: 'weekly', value: 'Semanal', disabled: false },
	{ id: 'monthly', value: 'Mensual', disabled: false },
	{ id: 'quarterly', value: 'Trimestral', disabled: false },
	{ id: 'biannual', value: 'Semestral', disabled: false },
	{ id: 'annually', value: 'Anual', disabled: false },
	{ id: 'other', value: 'Otra', disabled: false },
];

export const examTypes = [
	{ id: 'ingress', value: 'Ingreso' },
	{ id: 'periodic', value: 'Periódico' },
	{
		id: 'after30DaysAbsense',
		value: 'Después de ausencia > 30 días',
	},
	{ id: 'egress', value: 'Egreso' },
];

export const blankExam = {
	id: '',
	type: [],
	frequency: '',
};
